<template>
  <div class="main">
    <v-hover
      :disabled="i.child.length == 0"
      v-model="ishover[index]"
      close-delay="400"
      v-for="i ,index in category"
      :key="i.id">
    <v-btn
      text
      class="mr-1 white--text"
      @mouseenter="naventer(i)"
      @click="navclick(i)">
      {{i[$store.state.lang+'_name']}}
      <v-badge
        dot
        :value="i.child.length && i.isactive"
        color="pink">
        <template v-slot:badge>
          <span class="text-button">hot</span>
        </template>
        <v-icon v-if="i.child.length" small class="ml-1" color="white">mdi-chevron-down</v-icon>
      </v-badge>
    </v-btn>
  </v-hover>
  </div>
</template>
<script>
export default {
  name: 'Menubar',
  components: {

  },
  data: () => ({
    ishover:[false,false,false,false,false,false,false,false],
    navitem:[],
    category:[],
    category_io_api:'category/io/',
  }),
  methods:{
    naventer(v){
      if(v.child.length){
        this.$emit('naventer',v);
      }
    },
    navclick(obj){
      this.$router.push({
        path:obj.path,
        query:{
          flag:obj.id,
          ischild:'false',
        },
      });
    },
    fetch(){
      let postdata = {};
      postdata.startid = -1;
      this.$axios.post(this.$store.state.baseurl + this.category_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.category = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
  watch:{
    ishover(){
      this.$emit('navhover',this.ishover);
    }
  }
};
</script>
<style scoped>
.main{
  display:flex;
  flex-wrap:nowrap;
}
</style>